module.exports = __webpack_public_path__ + "img/Character_Mona_Thumb.08dbb6bb.png";